<template>
	<!-- <div class="notice_popup human int">
		<div class="tit" style="margin-left: 9px;">이력서를 등록해 주세요.</div>
		<div class="member" style="line-height: 35px;">‘이력서’를 등록해 주세요.<br/>그레이트프로의 신뢰높은 프로젝트에 지원 하실 수 있습니다.</div>
		<div class="select-btn">
			<div class="btn" @click="$emit('close', {viewNm:'MYP101M01'})">마이페이지로 가기</div>
			<div class="btn" @click="$emit('close', {viewNm:'PRF101M01'})">이력서 등록하기</div>
		</div>
	</div> -->
	<div class="popup-proj">
		<div class="close" @click="$emit('close')">
			<img src="/images/close.png" alt="닫기">
		</div>
		<div class="tit-meg">
			프로젝트에 지원하기 위한 
			<span style="color: #0165FF;">필수 등록항목</span>입니다
		</div>
		<div class="btn-box">
			<!-- 이력서 등록박스 --> 
			<div class="box-item yellow">
				<div class="tit">
					이력서 등록
				</div>
				<span>IT 프로 회원의<br /> 이력정보를 등록해 주세요.</span>
					<!-- 미등록/등록하기 -->
					<div v-if="regAgncYn === 'N' || prfCnt == 0" class="sub-btn-wrapper">						
						<div class="sub-btn" @click="$emit('close', {viewNm:'itpro/profile/resume'})">
							등록하기 <img src="/images/exc_ico.png" alt="미등록">
						</div>
					</div>
					<!-- 등록완료 -->
					<div v-else-if="regAgncYn === 'Y' || prfCnt > 0">
						<div class="sub-btn complete">
							등록완료 <img src="/images/check_ico.png" alt="등록완료">
						</div>
					</div>
			</div>

			<!-- 소속사 등록박스 -->
			<div class="box-item">
				<div class="tit">					
					소속사 등록
				</div>
				<span>회원님의 소속사를<br /> 입력해 주세요.</span>
				<div v-if="mberAsgRegYn == 'N'">
					 <div class="sub-btn complete" @click="$emit('close', {viewNm:'itpro/profile/affiliations'})">
						소속사 등록 <img src="/images/exc_ico.png" alt="미등록">
					</div>
				</div>
				<div v-else>
					<div class="sub-btn complete">
						등록완료 <img src="/images/check_ico.png" alt="등록완료">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['param'],

	data() {
		return {
			prfCnt : this.param.prfCnt,			
			mberAsgRegYn : this.param.mberAsgRegYn,
			regAgncYn: this.param.regAgncYn, 
		};
	},

	methods : {
		
	}
}
</script>